import {createSvgIcon} from '../create-svg-icon';

export const VolumeMuteIcon = createSvgIcon(
  <path d="M14 8.83v6.34L11.83 13H9v-2h2.83L14 8.83M16 4l-5 5H7v6h4l5 5V4z" />
, 'VolumeMuteOutlined');
